import { get, buildQueryString } from 'libs/GrebbCommerceAPI/util';

export default async (parameters = {}) => {
    // Build parameters.
    const builtParameters = buildQueryString(parameters);

    return await get(`/products/categories${builtParameters && `?${builtParameters}`}`);
};
